// extracted by mini-css-extract-plugin
module.exports = {"primary":"#FF7B19","primary1":"#FF9E56","primary2":"#f90","primary3":"#FF9A67","primary4":"#f5a623","primary5":"#ECAD4B","primary6":"#FC7900","primary7":"#FCECDF"};